import { InvalidDefinitionTypeError } from '../../errors/abi.js';
export function formatAbiItem(abiItem) {
  let {
    includeName = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (abiItem.type !== 'function' && abiItem.type !== 'event' && abiItem.type !== 'error') throw new InvalidDefinitionTypeError(abiItem.type);
  return "".concat(abiItem.name, "(").concat(formatAbiParams(abiItem.inputs, {
    includeName
  }), ")");
}
export function formatAbiParams(params) {
  let {
    includeName = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!params) return '';
  return params.map(param => formatAbiParam(param, {
    includeName
  })).join(includeName ? ', ' : ',');
}
function formatAbiParam(param, _ref) {
  let {
    includeName
  } = _ref;
  if (param.type.startsWith('tuple')) {
    return "(".concat(formatAbiParams(param.components, {
      includeName
    }), ")").concat(param.type.slice('tuple'.length));
  }
  return param.type + (includeName && param.name ? " ".concat(param.name) : '');
}
//# sourceMappingURL=formatAbiItem.js.map